const options = {
  // COIN
  'CV4R5T-S': {
    US: {
      WEEKLY_MONDAY: [],
      WEEKLY_TUESDAY: [],
      WEEKLY_WEDNESDAY: [],
      WEEKLY_THURSDAY: [],
      WEEKLY_FRIDAY: [
        {
          min_base_date: '2021-05-01',
          max_holding_period: 6,
          rebal_month: null,
        },
      ],
      MONTHLY: [
        {
          min_base_date: '2021-05-01',
          max_holding_period: 2,
          rebal_month: null,
        },
      ],
      QUARTERLY: [
        {
          min_base_date: '2021-04-01',
          max_holding_period: 6,
          rebal_month: 3,
        },
      ],
      ANNUALLY: [
        {
          min_base_date: '2021-05-01',
          max_holding_period: 24,
          rebal_month: 1,
        },
      ],
    },
  },
  // MSTR
  'B700XP-S': {
    US: {
      WEEKLY_MONDAY: [],
      WEEKLY_TUESDAY: [],
      WEEKLY_WEDNESDAY: [],
      WEEKLY_THURSDAY: [],
      WEEKLY_FRIDAY: [
        {
          min_base_date: '2021-04-01',
          max_holding_period: 6,
          rebal_month: null,
        },
      ],
      MONTHLY: [
        {
          min_base_date: '2006-01-01',
          max_holding_period: 1,
          rebal_month: null,
        },
        {
          min_base_date: '2023-11-01',
          max_holding_period: 2,
          rebal_month: null,
        },
      ],
      QUARTERLY: [
        {
          min_base_date: '2006-01-01',
          max_holding_period: 6,
          rebal_month: 1,
        },
      ],
      ANNUALLY: [
        {
          min_base_date: '2006-01-01',
          max_holding_period: 6,
          rebal_month: 1,
        },
        {
          min_base_date: '2007-01-01',
          max_holding_period: 24,
          rebal_month: 1,
        },
      ],
    },
  },
  // GOOG
  'DC1QVX-S': {
    US: {
      WEEKLY_MONDAY: [],
      WEEKLY_TUESDAY: [],
      WEEKLY_WEDNESDAY: [],
      WEEKLY_THURSDAY: [],
      WEEKLY_FRIDAY: [
        {
          min_base_date: '2014-05-01',
          max_holding_period: 6,
          rebal_month: null,
        },
        {
          min_base_date: '2014-05-01',
          max_holding_period: 5,
          rebal_month: null,
        },
        {
          min_base_date: '2014-11-15',
          max_holding_period: 1,
          rebal_month: null,
        },
      ],
      MONTHLY: [
        {
          min_base_date: '2014-05-01',
          max_holding_period: 1,
          rebal_month: null,
        },
        {
          min_base_date: '2014-07-23',
          max_holding_period: 2,
          rebal_month: null,
        },
        {
          min_base_date: '2021-04-08',
          max_holding_period: 4,
          rebal_month: null,
        },
        {
          min_base_date: '2022-05-23',
          max_holding_period: 6,
          rebal_month: null,
        },
      ],
      QUARTERLY: [
        {
          min_base_date: '2022-06-17',
          max_holding_period: 12,
          rebal_month: 3,
        },
        {
          min_base_date: '2014-05-01',
          max_holding_period: 7,
          rebal_month: 3,
        },
        {
          min_base_date: '2014-05-01',
          max_holding_period: 5,
          rebal_month: 3,
        },
      ],
      ANNUALLY: [
        {
          min_base_date: '2014-05-01',
          max_holding_period: 24,
          rebal_month: 1,
        },
      ],
    },
  },
};

export default options;
